export const NAME = 'authentication';
export const LOCALSTORAGE_KEY_AUTH_TOKEN = 'token';
export const LOCALSTORAGE_KEY_AUTH_TIMESTAMP = 'authTimestamp';
export const LOCALSTORAGE_KEY_AUTH_ISAUTHENTICATED = 'isAuthenticated';



// WEBPACK FOOTER //
// ./src/services/authentication/constants.js